'use strict'

const stateBoxSection = require('../sections/stateBox/stateBoxSection')
const stateStripSection = require('../sections/stateBox/stateStripSection')

module.exports = {
    stateBoxSection,
    stateStripSection
}
